module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 7c0-4.808-8.292-7-16-7S0 2.192 0 7c0 1.438.754 2.638 2 3.622V25c0 4.596 7.042 7 14 7s14-2.404 14-7V10.622c1.246-.984 2-2.184 2-3.622zM16 4c7.69 0 11.756 2.2 12.004 2.964C27.756 7.8 23.69 10 16 10S4.244 7.8 3.996 7.036C4.244 6.2 8.31 4 16 4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bucket-2.js
// module id = 1030
// module chunks = 14